import InvitationCreateContainer from './invitation_create_container';

const InvitationCreate = InvitationCreateContainer;
export default InvitationCreate;
